import { EMAIL_REGEXP } from 'src/utils/validation-schemes';
import { WORKFLOWS_ACTION_MESSAGES_TYPES } from 'src/pages/ConfigurationPage/WorkflowsTab/constants';

interface WorkflowAction {
  action_type?: string;
  action_escalated_list?: string;
  action_data_collection?: boolean;
  action_fields_name?: boolean;
  action_fields_email?: boolean;
  action_fields_phone_number?: boolean;
  action_fields_custom?: boolean;
  action_fields_custom_array?: Array<{ name?: string; description?: string }>;
  receiver_email_addresses?: string;
  action_message?: string;
  message_close?: string;
}

interface WorkflowData {
  action?: WorkflowAction[];
}

type SetErrorFn = (field: string, error: { message: string }) => void;

export const validateWorkflowActions = (
  data: WorkflowData,
  setError: SetErrorFn = () => {},
): boolean => {
  let isValid = true;

  if (!data.action) {
    return false;
  }

  data.action.forEach((action, index) => {
    const isDataCollectionChecked = [
      action.action_fields_name,
      action.action_fields_email,
      action.action_fields_phone_number,
      action.action_fields_custom,
    ].some(Boolean);
    const isActionTypeEscalate = action.action_type === 'escalate';
    const isEscalateOrForward =
      isActionTypeEscalate &&
      ['collect_and_escalate', 'forward_to_email'].includes(action.action_escalated_list);

    if (!action.action_data_collection && isEscalateOrForward && !isDataCollectionChecked) {
      setError(`action.${index}.action_data_collection`, {
        message: 'required',
      });

      isValid = false;
    }

    if (isEscalateOrForward && !isDataCollectionChecked) {
      setError(`action.${index}.action_fields_name`, {
        message: 'required',
      });
      setError(`action.${index}.action_fields_email`, {
        message: 'required',
      });
      setError(`action.${index}.action_fields_phone_number`, {
        message: 'required',
      });
      setError(`action.${index}.action_fields_custom`, {
        message: 'required',
      });

      isValid = false;
    }

    if (!action.receiver_email_addresses && action.action_escalated_list === 'forward_to_email') {
      setError(`action.${index}.receiver_email_addresses`, {
        message: 'required',
      });

      isValid = false;
    }

    if (
      action.action_escalated_list === 'forward_to_email' &&
      action.receiver_email_addresses &&
      !EMAIL_REGEXP.test(action.receiver_email_addresses)
    ) {
      setError(`action.${index}.receiver_email_addresses`, {
        message: 'Invalid Format',
      });

      isValid = false;
    }

    if (!action.action_escalated_list && isActionTypeEscalate) {
      setError(`action.${index}.action_escalated_list`, {
        message: 'required',
      });

      isValid = false;
    }

    if (!action.action_message && WORKFLOWS_ACTION_MESSAGES_TYPES.includes(action.action_type)) {
      setError(`action.${index}.action_message`, {
        message: 'required',
      });

      isValid = false;
    }

    if (!action.message_close && isActionTypeEscalate && action.action_escalated_list === 'close') {
      setError(`action.${index}.message_close`, {
        message: 'required',
      });

      isValid = false;
    }

    if (isActionTypeEscalate && action.action_fields_custom) {
      action.action_fields_custom_array.forEach((field, indx) => {
        if (!field.name) {
          setError(`action.${index}.action_fields_custom_array.${indx}.name`, {
            message: 'required',
          });

          isValid = false;
        }

        if (!field.description) {
          setError(`action.${index}.action_fields_custom_array.${indx}.description`, {
            message: 'required',
          });

          isValid = false;
        }
      });
    }
  });

  return isValid;
};
